// src/components/auth/LoginModal.js
import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import Button from '../common/Button';

function LoginModal({ onClose }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const success = login(email, password);
    if (success) {
      setError('');
      onClose();
    } else {
      setError('Invalid email or password');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-playfair-display text-primary mb-4">
          Log In
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-montserrat text-primary">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border border-primary rounded-md text-montserrat text-primary bg-cream"
              required
              aria-label="Email"
            />
          </div>
          <div>
            <label className="block text-sm font-montserrat text-primary">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 border border-primary rounded-md text-montserrat text-primary bg-cream"
              required
              aria-label="Password"
            />
          </div>
          {error && (
            <p className="text-red-600 text-sm font-montserrat">{error}</p>
          )}
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              onClick={onClose}
              className="bg-gray-500 text-cream px-4 py-2 text-sm font-montserrat rounded-full hover:bg-gray-600"
              aria-label="Cancel"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-primary text-cream px-4 py-2 text-sm font-montserrat rounded-full hover:bg-primary/90"
              aria-label="Log in"
            >
              Log In
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;